import { Box, Button, DialogActions, Stack } from '@mui/material';
import { ErrorBanner } from 'shared/ui/error-banner';
import { LegendItem, LegendList } from 'shared/ui/legend-list';
import { LoadingBanner } from 'shared/ui/loading-banner';
import { Dialog } from 'shared/ui/dialog';
import { useActionCreators, useStateSelector } from 'shared/store';
import { wccExportActions } from '../export-list/store-slice';
import { useWccExport } from '../lib';
import { downloadFile } from 'utils/download-file';
import { DownloadFileDto } from '@sr/dto';
import { useState } from 'react';

type Props = {
    onSuccess?: () => void;
};

export const WccExportProgressDialog = ({ onSuccess }: Props) => {
  const open = useStateSelector(state => state.wcc.export.dialogOpen);
  const idList = useStateSelector(state => state.wcc.export.checkedItems);
  const { closeDialog, uncheckAll } = useActionCreators(wccExportActions);

  const { runExport, report, loading, error, reset } = useWccExport();
  const [downloadedFiles, setDownloadedFiles] = useState<DownloadFileDto[]>([]);

  const handleClose = () => {
    reset();
    setDownloadedFiles([]);
    closeDialog();
  };

  const handleExport = () =>
    runExport(idList)
      .then((files: DownloadFileDto[]) => {
        uncheckAll();
        onSuccess?.();
        
        files.forEach((file) => {
          downloadFile(`/api/files/private/${file.id}`, file.fileName);
        });
        
        setDownloadedFiles(files);
      });

  const renderContent = () => {
    if (loading)
      return <LoadingBanner/>;

    if (error)
      return <ErrorBanner errorMessage={error}/>;

    if (report || downloadedFiles.length > 0)
      return (
        <Box>
          <LegendList>
            <LegendItem 
              title="Создано файлов" 
              value={`${downloadedFiles.length} шт.`}
            />
          </LegendList>
          
          {downloadedFiles.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <ul style={{ marginTop: '8px', marginBottom: 0 }}>
                {downloadedFiles.map((file, index) => (
                  <li key={index}>
                    {file.fileName} ({Math.round(file.size)} KB)
                  </li>
                ))}
              </ul>
            </Box>
          )}
        </Box>
      );

    return (
      <Box>
        {`Экспортировать ${idList.length} актов?`}
      </Box>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth='lg'
    >
      <Dialog.Title>
        Экспорт актов
      </Dialog.Title>

      <Dialog.Content>
        {renderContent()}
      </Dialog.Content>

      <DialogActions sx={{ flex: 1, flexDirection: 'row' }}>
        <Stack direction="row" justifyContent="flex-start" spacing={1}>
          <Button
            variant="contained"
            disabled={loading || downloadedFiles.length > 0}
            onClick={handleExport}
          >
            экспортировать
          </Button>

          <Button
            variant="outlined"
            disabled={loading}
            onClick={handleClose}
          >
            закрыть
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
